import { render, staticRenderFns } from "./u-btn-arrow-text-fit.vue?vue&type=template&id=f6cf1ea8&scoped=true&"
import script from "./u-btn-arrow-text-fit.vue?vue&type=script&lang=js&"
export * from "./u-btn-arrow-text-fit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cf1ea8",
  null
  
)

export default component.exports